module.exports = __webpack_public_path__ + "static/media/news-hailey.d0554227.jpg";